import { render, staticRenderFns } from "./RegisterViewPad.vue?vue&type=template&id=535a36d8&scoped=true"
import script from "./RegisterViewPad.vue?vue&type=script&lang=js"
export * from "./RegisterViewPad.vue?vue&type=script&lang=js"
import style0 from "./RegisterViewPad.vue?vue&type=style&index=0&id=535a36d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535a36d8",
  null
  
)

export default component.exports